import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FeeClass from "./FeeClass";
import FeeTemplate from "./FeeTemplate";
import ApproveTransaction from "./ApproveTransaction";
import ApproveDiscount from "./ApproveDiscount";
import ReportDetails from "./ReportDetails";
import FeeDashboard from "./FeeDashboard";
import SmsWalletSettings from "./SmsWalletSettings";

const tabs = [
  { key: "dashboard",        label: "Dashboard" },
  { key: "classes",          label: "Fee Register" },
  { key: "approve",          label: "Approve Transaction" },
  { key: "approve-discount", label: "Approve Discount" },
  { key: "report",           label: "Report" },
  { key: "template",         label: "Template" },
  { key: "sms-wallet",       label: "SMS Wallet" },
];

const SwitchAdmission = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname.split("/").pop() || "dashboard";

  const [feeClassRefreshKey, setFeeClassRefreshKey] = useState(0);
  const onFeeApproval = () => setFeeClassRefreshKey((k) => k + 1);

  return (
    <>
      <div className="p-8">
        {/* Tab bar */}
        <div
          className="bg-white rounded-lg"
          style={{ display: "grid", gridTemplateColumns: `repeat(${tabs.length}, 1fr)` }}
        >
          {tabs.map(({ key, label }) => (
            <div
              key={key}
              onClick={() => navigate(`/dashboard/admin/menu/fee/${key}`)}
              className={`iskool-tab-item ${
                currentTab === key ? "bg-gray-600 text-white shadow" : ""
              }`}
            >
              <div className="text-lg">{label}</div>
            </div>
          ))}
        </div>

        {/* All panels rendered; only the active one is visible — preserves state on tab switch */}
        <div style={{ display: currentTab === "dashboard" || currentTab === "fee" ? "block" : "none" }}>
          <FeeDashboard />
        </div>
        <div style={{ display: currentTab === "classes" ? "block" : "none" }}>
          <FeeClass refreshKey={feeClassRefreshKey} />
        </div>
        <div style={{ display: currentTab === "approve" ? "block" : "none" }}>
          <ApproveTransaction onApproval={onFeeApproval} />
        </div>
        <div style={{ display: currentTab === "approve-discount" ? "block" : "none" }}>
          <ApproveDiscount onApproval={onFeeApproval} />
        </div>
        <div style={{ display: currentTab === "report" ? "block" : "none" }}>
          <ReportDetails />
        </div>
        <div style={{ display: currentTab === "template" ? "block" : "none" }}>
          <FeeTemplate />
        </div>
        <div style={{ display: currentTab === "sms-wallet" ? "block" : "none" }}>
          <SmsWalletSettings />
        </div>
      </div>
    </>
  );
};

export default SwitchAdmission;

